
export const SOCIALS = {
    INSTAGRAM: 'https://instagram.com/_simona_cherry_',
    TIKTOK: 'https://www.tiktok.com/@studio_cherry',
    WHATSAPP: 'https://api.whatsapp.com/send?phone=972544601846',
    EMAIL: 'simona@simonacherry.com',
};

export const whatsAppLink = text=>`${SOCIALS.WHATSAPP}${text ? `&text=${encodeURIComponent(text)}` : ''}`;
